export default __webpack_public_path__ + "static/media/customError.f14f1dae.svg";